export function isFileWithNestedName(obj: unknown): obj is { file: { name: string } } {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        'file' in obj &&
        typeof (obj as any).file === 'object' &&
        (obj as any).file !== null &&
        'name' in (obj as any).file &&
        typeof (obj as any).file.name === 'string'
    );
}

export function isHasName(obj: unknown): obj is { name: string } {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        'name' in obj &&
        typeof (obj as any).name === 'string'
    );
}
